function LinkPdf() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A link to a PDF document is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Unless authored with accessibility in mind, PDF documents often have accessibility issues. Additionally, PDF documents are typically viewed using a separate application or plug-in, and can thus cause confusion and navigation difficulties.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the PDF document is natively accessible. Additionally, inform the user that the link will open a PDF document. Because PDF documents may have limitations in accessibility (particularly for complex content) and require a separate program, HTML content should often be used in place of or in addition to the PDF document.</p>
    </blockquote>
  )
}

export default LinkPdf